
import { VueConstructor } from 'vue';
import { ContentBlockType } from 'fourwaves-shared';
import { ContentBlockModel } from 'fourwaves-shared/src/services';
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import LegacyTextBlock from './content-blocks/LegacyTextBlock.vue';
import TextBlock from './content-blocks/TextBlock.vue';
import TextImageBlock from './content-blocks/TextImageBlock.vue';
import SpeakersBlock from './content-blocks/speakers-block/SpeakersBlock.vue';
import AccordionBlock from './content-blocks/accordion-block/AccordionBlock.vue';
import GalleryBlock from './content-blocks/gallery-block/GalleryBlock.vue';
import LogosBlock from './content-blocks/LogosBlock.vue';
import FileBlock from './content-blocks/FileBlock.vue';
import MultiRowsBlock from './content-blocks/multi-rows-block/MultiRowsBlock.vue';
import MultiColumnsBlock from './content-blocks/multi-columns-block/MultiColumnsBlock.vue';
import BannerBlock from './content-blocks/BannerBlock.vue';
import VideoBlock from './content-blocks/VideoBlock.vue';

@Component
export default class ContentBlockList extends Vue {
  @Prop({ type: Array, required: true }) readonly blocks!: ContentBlockModel[];

  public readonly contentBlockComponentsMap: Partial<Record<ContentBlockType, VueConstructor>> = {
    [ContentBlockType.LegacyRichTextEditor]: LegacyTextBlock,
    [ContentBlockType.RichTextEditor]: TextBlock,
    [ContentBlockType.TextImage]: TextImageBlock,
    [ContentBlockType.Speakers]: SpeakersBlock,
    [ContentBlockType.Accordion]: AccordionBlock,
    [ContentBlockType.Images]: GalleryBlock,
    [ContentBlockType.Logos]: LogosBlock,
    [ContentBlockType.File]: FileBlock,
    [ContentBlockType.MultiRows]: MultiRowsBlock,
    [ContentBlockType.MultiColumns]: MultiColumnsBlock,
    [ContentBlockType.Banner]: BannerBlock,
    [ContentBlockType.Video]: VideoBlock,
  };
}
